import useExpandable from "../../../hooks/useExpandable";

const WORDS_TO_SHOW = 15;

/**
 * Product description with read more/less functionality
 */
const ProductDescription = ({ catalogDescription }) => {
  const { displayContent, isExpanded, needsExpansion, toggle } = useExpandable(
    catalogDescription,
    WORDS_TO_SHOW
  );

  if (!catalogDescription) {
    return null;
  }

  const readMoreLabel = window.globalProperties?.["readMoreLabel"] || "Read More";
  const readLessLabel = window.globalProperties?.["readLessLabel"] || "Read Less";

  return (
    <div className="pdp-header__description-wrapper">
      <p className="pdp-header__description">
        {displayContent}{needsExpansion && !isExpanded && "..."}&nbsp;&nbsp;
        {needsExpansion && (
          <button
            className="pdp-header__description-toggle"
            onClick={toggle}
          >
            <span className="pdp-header__description-toggle-text">
              {isExpanded ? readLessLabel : readMoreLabel}
            </span>
            {isExpanded ? (
              <span className="pdp-header__description-toggle-icon darticon-arrow-up"></span>
            ) : (
              <span className="pdp-header__description-toggle-icon darticon-arrow-down"></span>
            )}
          </button>
        )}
      </p>
    </div>
  );
};

export default ProductDescription;
